import { style, keyframes } from '@vanilla-extract/css'

const fade = keyframes({
  '0%': { opacity: 1 },
  '15%': { opacity: 1 },
  '25%': { opacity: 0 },
  '90%': { opacity: 0 },
  '100%': { opacity: 1 },
})

const section = style({
  background: `
    linear-gradient(0deg, #EAEBE0, #EAEBE0),
    linear-gradient(180.01deg, rgba(242, 241, 239, 0) 40.8%, #F2F1EF 99.99%);
  `,
})

const images = style({
  position: 'relative',
  aspectRatio: '1',
  width: '100%',
})

const image = style({
  width: '100%',
  position: 'absolute',
  willChange: 'opacity',
  animationName: fade,
  animationDuration: '12s',
  animationIterationCount: 'infinite',
  animationTimingFunction: 'ease-out',
  borderRadius: '24px',
})

const heading = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontSize: '19px',
  fontWeight: '700',
  lineHeight: '1.5',
  textAlign: 'center',
})

const text = style({
  fontSize: '15px',
  lineHeight: '1.5',
})

const button = style({
  fontSize: '15px',
  fontWeight: '700',
  lineHeight: '1.5',
  textDecoration: 'none',
  boxShadow: '0px 4px 16px 0px #0000000D',
  padding: '16px 24px',
  borderRadius: '24px',
  backgroundColor: 'white',
})

export const styles = {
  section,
  images,
  image,
  heading,
  text,
  button,
}
